import { ReactNode } from "react";

import Box from "ds/components/Box";

import styles from "./styles.module.css";

type ProviderVersionDocsPageWrapperProps = {
  children: ReactNode;
};

const ProviderVersionDocsPageWrapper = ({ children }: ProviderVersionDocsPageWrapperProps) => {
  return (
    <Box className={styles.wrapper} direction="column">
      {children}
    </Box>
  );
};

export default ProviderVersionDocsPageWrapper;
